import { render, staticRenderFns } from "./TermsOfServiceConsent.vue?vue&type=template&id=52726e94&"
import script from "./TermsOfServiceConsent.vue?vue&type=script&lang=js&"
export * from "./TermsOfServiceConsent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports